// var demoTrigger = document.querySelector('.product-image');
// var paneContainer = document.querySelector('.product-info');

// new Drift(demoTrigger, {
//   paneContainer: paneContainer,
//   inlinePane: false,
// });

const images = document.querySelectorAll(".cstm_zoom img");
images.forEach((image) => {
  new Drift(image, {
    paneContainer: document.querySelector(".details"),
    inlinePane: 769,
    inlineOffsetY: -85,
    containInline: true,
    hoverBoundingBox: true,
  });
});
